module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XIII",
      "role": "doc-pagebreak",
      "title": "XIII"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Image",
      "id": "pre1_2",
      "src": "images/pre1.jpg"
    }
  })])]), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_c('span', [_vm._v("Abbreviations")])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "2px"
    }
  }, [_c('col', {
    staticStyle: {
      "padding": "2px"
    }
  }), _c('col', {
    staticStyle: {
      "width": "81.818181818182%"
    }
  })]), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("BET")])])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("Bulletin of Ecclesial Theology")])])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("BETL")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Bibliotheca Ephemeridum Theologicarum Lovaniensium")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("BST")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Bible Speaks Today")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("BTCB")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Brazos Theological Commentary on the Bible")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("CBQ")])])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("Catholic Biblical Quarterly")])])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("ESBT")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Essential Studies in Biblical Theology")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("IBC")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Interpretation: A Bible Commentary for Teaching and Preaching")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("Int")])])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("Interpretation")])])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("JBL")])])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("Journal of Biblical Literature")])])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("JR")])])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("Journal of Religion")])])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("NAC")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("New American Commentaries")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("NCBC")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("New Cambridge Bible Commentary")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("NICNT")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("New International Commentary on the New Testament")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("NICOT")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("New International Commentary on the Old Testament")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("NIGTC")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("New International Greek Testament Commentary")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("NIV")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("New International Version")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("NIVAC")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("New International Version Application Commentary")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("NSBT")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("New Studies in Biblical Theology")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XIV",
      "role": "doc-pagebreak",
      "title": "XIV"
    }
  }, [_vm._v("NTT")])])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("New Testament Theology")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("OTL")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Old Testament Library")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("PNTC")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Pillar New Testament Commentary")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("THOTC")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Two Horizons Old Testament Commentary")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("TNTC")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Tyndale New Testament Commentaries")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("TOTC")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Tyndale Old Testament Commentaries")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("WBC")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Word Biblical Commentary")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("WTJ")])])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("Westminster Theological Journal")])])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("ZECNT")])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Zondervan Exegetical Commentary on the New Testament")])])]), _c('tr', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("ZNW")])])]), _c('td', {
    staticStyle: {
      "padding": "2px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche")])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 72
// module chunks = 0